var _path, _path2, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBorder2(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 113,
    height: 237,
    viewBox: "0 0 113 237",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M57 165H22C10.402 165 1 155.598 1 144V0",
    stroke: "url(#paint0_linear_1536_550)",
    strokeOpacity: 0.2
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M113 101H78C66.402 101 57 110.402 57 122V237",
    stroke: "url(#paint1_linear_1536_550)",
    strokeOpacity: 0.2
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1536_550",
    x1: 29,
    y1: 0,
    x2: 29,
    y2: 165,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97A3B6"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1536_550",
    x1: 85,
    y1: 237,
    x2: 85,
    y2: 101,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "white",
    stopOpacity: 0
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#97A3B6"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBorder2);
export default __webpack_public_path__ + "static/media/border2.ec8674e45b7f9911a3dc55eb25604d8e.svg";
export { ForwardRef as ReactComponent };